<template>
  <v-content>
    <v-overlay v-if="loadingOverlay === true">
      <div>Loading Page...</div>
    </v-overlay>
    <v-container v-if="campaignData !== null">
      <v-alert :value="displayAlert" :color="alertType">{{alertMsg}}</v-alert>
      <v-flex>
        <H4 class="subheading grey--text">
          <a href="/influencer-campaign/list">All Campaigns</a>
          > {{campaignData.business.businessName}} - {{campaignData.name}}
        </H4>
        <v-spacer></v-spacer>
        <v-btn @click.stop="openAddInfluencer">Add Influencer</v-btn>
      </v-flex>

      <v-simple-table>
        <thead>
          <tr>
            <th class="text-left">Instagram</th>
           
            <th class="text-left">Bio</th>
            <th class="text-left">Followers</th>
            <th class="text-left">Engagent Rate</th>
            <th class="text-left">Email</th>
            <th class="text-left">Status</th>
            <th class="text-left"></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="candidate in campaignCandidateList" :key="candidate._id">
            <td style="width: 150px;">
              <a :href="'https://instagram.com/'+candidate.fullProfile.profileName" target="_blank">
                <v-img :src="candidate.fullProfile.profilePic" class="influencer-img"></v-img>
              </a>

              <a
                :href="'https://instagram.com/'+candidate.fullProfile.profileName"
                target="_blank"
              >@{{candidate.fullProfile.profileName}}</a>
            </td>

           
            <td style="width: 200px;">{{candidate.fullProfile.bio}}</td>
            <td>{{candidate.fullProfile.followerCount}}</td>
            <td>{{ (candidate.fullProfile.engagementRate * 100).toFixed(2) }}%</td>
            <td>{{candidate.fullProfile.email}}</td>
            <td>{{candidate.status}}</td>
            <td>
              <v-btn :to="'/influencer-campaign/candidate/'+candidate._id">DETAILS</v-btn>
            </td>
          </tr>
        </tbody>
      </v-simple-table>

      <v-dialog v-model="addInfluencerModal" max-width="60%">
        <v-card>
          <v-card-title class="headline">Add Influencer to {{campaignData.name}}</v-card-title>

          <v-card-text>
            <v-text-field
              label="Instagram Profile"
              id="ig_profile"
              name="ig_profile"
              outlined
              v-model="instagram"
              :rules="igRules"
              @blur="igProfileCheck"
              required
            ></v-text-field>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn color="green darken-1" text @click="addInfluencer">SUBMIT</v-btn>

            <v-btn color="green darken-1" text @click="cancelAddInfluencer">CANCEL</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
  </v-content>
</template>
<script>
import firebase from "firebase";
import axios from "axios";
import numeral from "numeral";
import IGProfileData from "@/libs/ig/profileData";
import {
  influencerCampaignSearchApi,
  influencerCampaignReadApi,
  influencerCampaignCandidateListApi,
  influencerCampaignCandidateAddApi
} from "@/config/appSettings";
export default {
  data: () => ({
    loadingOverlay: false,
    loadingText: null,
    campaigns: null,
    campaignData: null,
    campaignId: null,
    campaignCandidateList: null,
    addInfluencerModal: false,
    instagram: null,
    alertMsg: null,
    alertType: null,
    displayAlert: false,
    igRules: [v => !!v || "Enter a valid Instagram profile"]
  }),
  name: "InfluencerCampaignManage",
  methods: {
    async loadCampaignList() {
      try {
        this.loadingOverlay = true;
        let influencerCampaignSearchUrl = `${influencerCampaignSearchApi}/?usertoken=${this.auth}`;
        console.log("INFLUENCER CAMPAIGN:", influencerCampaignSearchUrl);
        let influencerCampaignList = await axios.get(
          influencerCampaignSearchUrl
        );
        console.log("CAMPAIGN DATA: ", influencerCampaignList.data);
        if (influencerCampaignList.data.success === true) {
          this.campaigns = influencerCampaignList.data.result;
          this.loadingOverlay = false;
        }
      } catch (err) {
        console.log("CAMPAIGN LIST ERROR: ", err);
      }
    },
    async loadCampaign() {
      this.loadingOverlay = true;
      this.loadingText = "LOADING CAMPAIGN...";

      //console.log("HERE IS THE CAMPAIGN ID:", campaignId);
      let campaignLoadResponse = await axios.get(
        `${influencerCampaignReadApi}/?usertoken=${this.auth}&campaign=${this.campaignId}`
      );
      console.log(
        "HERE IS THE CAMPAIGN LOAD RESPONSE:",
        campaignLoadResponse.data
      );
      if (campaignLoadResponse.data.success === true) {
        this.campaignData = campaignLoadResponse.data.result;
        this.loadInfluencerCandidates();
        //this.loadingOverlay = false;
        //this.loadingText = null;
        return;
      }
      this.loadingText = "There was an error loading. Refresh page.";
    },
    async loadInfluencerCandidates() {
      this.loadingOverlay = true;
      this.loadingText = "LOADING INFLUENCERS...";

      //console.log("HERE IS THE CAMPAIGN ID:", campaignId);

      let candidateListUrl = `${influencerCampaignCandidateListApi}/?usertoken=${this.auth}&campaign=${this.campaignId}`;

      console.log("CANDIDATE LIST URL:", candidateListUrl);

      let influencerCandidateLoadResponse = await axios.get(candidateListUrl);
      console.log(
        "HERE IS THE CANDIDATE LIST RESPONSE:",
        influencerCandidateLoadResponse.data
      );
      if (influencerCandidateLoadResponse.data.success === true) {
        this.campaignCandidateList =
          influencerCandidateLoadResponse.data.result;
        this.loadingOverlay = false;
        this.loadingText = null;
        return;
      }
      this.loadingText = "There was an error loading. Refresh page.";
    },
    async igProfileCheck() {
      try {
        let profileName = this.instagram.replace(/[^a-zA-Z0-9_.]/g, "");
        if (typeof profileName === "undefined") {
          this.igRules = ["Please enter a profile"];
          return false;
        }
        let igCheckResponse = await IGProfileData.getProfileDataDirect(
          profileName
        );
        if (igCheckResponse.success === false) {
          this.igRules = ["Please enter a valid profile"];
          return false;
        }
        console.log("VALID PROFILE");
        this.igRules = [true];
        return igCheckResponse.result;
      } catch (err) {
        console.log("THERE WAS AN ERROR", err);
        this.igRules = ["Please check Instagram profile."];
        return false;
      }
    },
    async addInfluencer() {
      try {
        if (this.igProfileCheck()) {
          console.log("PROFILE CHECK SUCCESSFUL");
          let influencerData = {};
          influencerData.instagram = this.instagram;
          influencerData.usertoken = this.auth;
          influencerData.campaign = this.campaignId;
          console.log("SEND IMAGE:", influencerData);
          let addInfluencerResponse = await axios.post(
            influencerCampaignCandidateAddApi,
            influencerData
          );
          console.log("INFLUENCER RESPONSE:", addInfluencerResponse.data);
          if (addInfluencerResponse.data.success === true) {
            this.instagram = null;
            this.addInfluencerModal = false;
            this.alertMsg = "Profile added successfully.";
            this.displayAlert = true;
            this.alertType = "success";
            this.loadInfluencerCandidates();
            return;
          }
          return;
        }
        console.log("CHECK FAILED");
      } catch (err) {
        console.log("THERE WAS AN ERROR:", err);
      }
    },
    async cancelAddInfluencer() {
      this.instagram = null;
      this.addInfluencerModal = false;
    },
    async openAddInfluencer() {
      this.instagram = null;
      this.addInfluencerModal = true;
    }
  },

  mounted() {
    this.auth = firebase.auth().currentUser.uid;
    this.campaignId = this.$route.params.campaignId;
    this.loadCampaign();
  }
};
</script>

<style scoped>
.influencer-img {
  width: 50px;
  margin: 10px;
  border-radius: 5px;
}
</style>